import { mapValuesDeep, scrollToError } from '@application/utils';
import { AnimalTypeEnum } from '@gql/graphql';
import { Form, FormikProvider, useFormik } from 'formik';
import type { FC } from 'react';
import { useImperativeHandle } from 'react';
import { MtFormButtons } from '..';
import { FormDog } from './components/FormDog';
import { FormGeneral } from './components/FormGeneral';
import { FormBookingGeneral } from './components/FormBookingGeneral';
import * as Styled from './styled';
import type { BuyerAnimalFormMethods, BuyerAnimalFormProps } from './types';

export * from './types';

export const BuyerAnimalForm: FC<BuyerAnimalFormProps> = (props) => {
  const { form, mode, onCancelClick, customSubmitButtons, refId, isBookingForm = false } = props;

  const formProps = useFormik({
    enableReinitialize: true,
    initialValues: form.initialValues,
    onSubmit: form.onSubmit,
    validate: form.validate,
    validationSchema: form.validationSchema,
  });

  useImperativeHandle(
    refId,
    () =>
      ({
        validateForm: async () => {
          formProps.setTouched(mapValuesDeep(formProps.initialValues, () => true));
          return formProps.validateForm();
        },
        getValues: () => formProps.values,
      } as BuyerAnimalFormMethods as any),
  );

  const animalIsADog = formProps.values.type === AnimalTypeEnum.DOG;
  return (
    <FormikProvider value={formProps}>
      <Form ref={refId}>
        {isBookingForm ? (
          <FormBookingGeneral {...props} />
        ) : (
          <>
            <FormGeneral {...props} />
            {formProps.values.type === AnimalTypeEnum.DOG ? <FormDog {...props} /> : null}
          </>
        )}

        {animalIsADog ? <Styled.Spacer /> : null}
        {!customSubmitButtons ? (
          <MtFormButtons
            showCancel={mode !== 'view'}
            showSubmit={mode !== 'view'}
            onSubmitClick={async () => {
              await formProps.submitForm();
              scrollToError(formProps.errors);
            }}
            submitLoading={formProps.isSubmitting}
            onCancelClick={(event) => {
              formProps.resetForm();
              onCancelClick?.(event);
            }}
          />
        ) : (
          customSubmitButtons(formProps)
        )}
      </Form>
    </FormikProvider>
  );
};
